import React from "react";
import CourseDetailTemplate from "./CourseDetailTemplate";
const CURRICULUM = [
  "HTML, CSS, and JavaScript (Basics to Advanced)",
  "Front-End Frameworks (React, Angular, Vue.js)",
  "Back-End Development (Node.js, Express, Django, Flask)",
  "Database Management (SQL, NoSQL, MongoDB)",
  "Responsive Design and Bootstrap Framework",
  "RESTful APIs and Microservices",
  "Deployment and DevOps (Docker, Kubernetes, AWS, CI/CD)",
  "Web Security (Authentication, Authorization, Best Practices)",
];
const STRUCTURE = [
  { title: "Admission",                      desc: "Eligibility check and onboarding process." },
  { title: "Training / Learning — 3 Months", desc: "Intensive hands-on training with expert mentors." },
  { title: "Mock Interview",                 desc: "Score minimum 3.5 out of 5 to progress." },
  { title: "Live Project — 3 Months",        desc: "Work on real industry-grade projects." },
  { title: "Monthly Assessment & Report",    desc: "Track progress with regular evaluations." },
  { title: "Certification & Job Support",    desc: "Certification and job opening references." },
];
const WebProgramming = () => (
  <CourseDetailTemplate title="Web Programming Course"
    description="Build dynamic, responsive websites and applications! Master front-end, back-end, and full-stack development. Develop the skills to create user-friendly, scalable web solutions."
    curriculum={CURRICULUM} structure={STRUCTURE}
    tags={["HTML", "CSS", "JavaScript", "React", "Node.js", "MongoDB"]}
    programName="Web Programming Course"
  />
);
export default WebProgramming;
